import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult,
} from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult>({
    distribution: number,
  });

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult>({
    distribution: number,
  });
